let locationsData = [
 {
  shopId: 'domenicos',
  id: 'domenicos',
  // instagram: "sushi_.yu",
  basePath: "/pasadena", 
  cssGlobalPrefix: 'pablitoschicken',
  mapLogo: '/domenicos.png',
  // disabled: true, openingDate: "visit/call to order",
  label: "Pasadena",
  className: 'night',
  address: ["2411 E Washington Blvd", "Pasadena, CA 91104"],
  phone: "(626) 797-6459",
  phoneLink: "+16267976459",
  lat: 34.1693115, lng: -118.1056681,
  orderLink: "/pasadena/order",
  storefrontPhoto: "https://afag.imgix.net/domenicos-italian-restaurant/exterior.jpg?w=800&auto=format",
  hours: [
    { day: 'Monday', hours: 'Closed' },
    { day: 'Tuesday', hours: 'Closed' },
    { day: 'Wednesday', hours: '11 AM–9 PM' },
    { day: 'Thursday', hours: '11 AM–9 PM' },
    { day: 'Friday', hours: '11 AM–9:30 PM' },
    { day: 'Saturday', hours: '11 AM–9:30 PM' },
    { day: 'Sunday', hours: '11 AM–9 PM' },
  ]},
];


const siteData = {
  siteLogo: "https://afag.imgix.net/domenicos-italian-restaurant/logo.png?w=500&auto=format",
  domain: "domenicospasadena.com",
  name: "Domenico's Pasadena | Order Delivery & Takeout",
  shortName: "Domenico's Pasadena",
  description: "Enjoy classic Italian cuisine at Domenico's Pasadena. Serving delicious pizza, pasta, and Italian favorites in a warm, family-friendly setting.",
  folderId: 'domenicos',
  ogImage: "https://afag.imgix.net/domenicos-italian-restaurant/logo.png?w=1200&auto=format",
  iconRoot: "/domenicos.png",
}

export { siteData };
export default locationsData;

